import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<
	['title', 'description', 'buttonName', 'dismissLabel']
> = defineContent({
	default: {
		title: {
			id: 'jira-crossflow-recommendation-jpd.banner-title',
			defaultMessage: 'Revitalize your roadmap',
			description: 'Title for the JPD crossflow recommendation banner',
			role: 'title',
		},
		description: {
			id: 'jira-crossflow-recommendation-jpd.banner-description',
			defaultMessage:
				'Try Jira Product Discovery to explore, discuss, and prioritize ideas\u2014then move the best ones straight into Jira.',
			description: 'Description for the JPD crossflow recommendation banner',
			role: 'description',
		},
		buttonName: {
			id: 'jira-crossflow-recommendation-jpd.banner-button',
			defaultMessage: 'Try it',
			description: 'CTA button text for the JPD crossflow recommendation banner',
		},
		dismissLabel: {
			id: 'jira-crossflow-recommendation-jpd.banner-dismiss',
			defaultMessage: 'Dismiss',
			description: 'Dismiss button label for the JPD crossflow recommendation banner',
		},
	},
});
